import { render, staticRenderFns } from "./BatchOperationReview.vue?vue&type=template&id=76e766de&scoped=true&"
import script from "./BatchOperationReview.vue?vue&type=script&lang=js&"
export * from "./BatchOperationReview.vue?vue&type=script&lang=js&"
import style0 from "./BatchOperationReview.vue?vue&type=style&index=0&id=76e766de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e766de",
  null
  
)

export default component.exports